import type { InputType } from 'config'
import { EmailAssigneeOptions } from 'pages/Tasks/constants'

export const EmailGroup: Record<string, string> = {
  loanSubmission: 'Loan Submission',
  loanAction: 'Loan Actions',
  loan: 'Loan',
  user: 'User',
}

export const EmailPurposeOptions: Record<string, string> = {}

export const defaultInputs = (): Record<string, InputType> => {
  return {
    title: {
      inputType: 'text',
      title: 'Email Template Name',
      required: true,
    },
    from: {
      inputType: 'select',
      title: 'Email From',
      options: {},
      hasDefaultOption: true,
      required: true,
    },
    purpose: {
      title: 'Email Purpose',
      inputType: 'multiselect',
      required: false,
      options: EmailPurposeOptions,
      sort: true,
      value: [],
      sortKey: 'value',
    },
    to: {
      inputType: 'autocomplete',
      type: 'email',
      title: 'Email To',
      required: false,
    },
    cc: {
      inputType: 'autocomplete',
      type: 'email',
      title: 'Email To CC',
      required: false,
    },
    group: {
      title: 'Email Group',
      inputType: 'Select',
      required: true,
      options: EmailGroup,
      hasDefaultOption: true,
    },
    subject: {
      inputType: 'text',
      title: 'Email Subject',
      required: true,
    },
    elements: {
      title: 'Email Elements',
      inputType: 'multiselect',
      required: false,
      options: {},
      value: [],
    },
    content: {
      inputType: 'textarea',
      title: 'Email Content',
      required: false,
      rows: 15,
      span: 'full',
    },
  }
}

export const automationInputs = (loanStatusOptions: Record<string, string>): Record<string, InputType> => {
  return {
    loanStatus: {
      inputType: 'multiselect',
      title: 'Loan Status',
      options: loanStatusOptions,
      defaultSelected: false,
      required: true,
    },
    duration: {
      inputType: 'text',
      type: 'number',
      title: 'Days',
      required: true,
    },
    to: {
      inputType: 'multiselect',
      title: 'Email To',
      options: EmailAssigneeOptions(),
      defaultSelected: false,
      required: true,
    },
  }
}

export const emailConfigurationInputs = (): Record<string, InputType> => {
  return {
    facebook: {
      inputType: 'text',
      type: 'url',
      title: 'Facebook URL',
      value: '',
      required: false,
    },
    twitter: {
      inputType: 'text',
      type: 'url',
      title: 'X URL',
      value: '',
      required: false,
    },
    instagram: {
      inputType: 'text',
      type: 'url',
      title: 'Instagram URL',
      value: '',
      required: false,
    },
    linkedin: {
      inputType: 'text',
      type: 'url',
      title: 'LinkedIn URL',
      value: '',
      required: false,
    },
    youtube: {
      inputType: 'text',
      type: 'url',
      title: 'Youtube URL',
      value: '',
      required: false,
    },
  }
}
